/** Аватар: квадрат 256×256 JPEG ~0.9, обрезка по центру (S4). */
export const AVATAR_SIZE = 256;
export const AVATAR_QUALITY = 0.9;
/** Исходная картинка не больше 5 МБ. */
export const AVATAR_MAX_BYTES = 5 * 1024 * 1024;

export const AVATAR_TEXTS = {
    upload: "Загрузить фото",
    remove: "Удалить фото",
    tooLarge: "Картинка больше 5 МБ",
} as const;

/** Квадрат по центру исходника: сторона — меньшая из сторон. */
export const centerSquare = (width: number, height: number) => {
    const side = Math.min(width, height);
    return {sx: Math.floor((width - side) / 2), sy: Math.floor((height - side) / 2), side};
};

const loadImage = (file: Blob): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("image"));
        };
        img.src = url;
    });

/** Файл картинки → JPEG 256×256 (обрезка по центру); прозрачность — на белом. */
export const cropAvatar = async (file: Blob): Promise<File> => {
    const img = await loadImage(file);
    const {sx, sy, side} = centerSquare(img.naturalWidth, img.naturalHeight);
    const canvas = document.createElement("canvas");
    canvas.width = AVATAR_SIZE;
    canvas.height = AVATAR_SIZE;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("canvas");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, AVATAR_SIZE, AVATAR_SIZE);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(img, sx, sy, side, side, 0, 0, AVATAR_SIZE, AVATAR_SIZE);
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", AVATAR_QUALITY));
    if (!blob) throw new Error("canvas");
    return new File([blob], "avatar.jpg", {type: "image/jpeg"});
};
